import classNames from 'classnames';
import Link from 'next/link';
import * as React from 'react';
import {
  MultipleLineTruncate,
  SingleLineTruncate,
} from '../../../../../components/LineTruncate';
import MerchantTag from '../../tags/MerchantTag';
import LowestPrice from '../../texts/LowestPrice';
import { BookingPageTagName } from '../../../../../domain/entities/BookingPage';
import css from './BookingPageCard.module.scss';

interface Props {
  className?: string;
  title: string;
  description: string;
  thumbnailUrl: string;
  url: string;
  tags: BookingPageTagName[];
  lowestPrice?: number;
}

const BookingPageCard = (props: Props) => {
  return (
    <div className={classNames(css.BookingPageCard, props.className)}>
      <Link
        href={props.url}
        prefetch={false}
        className={css.BookingPageCard__Link}
      >
        <div>
          {props.thumbnailUrl && (
            <div className={css.BookingPageCard__Thumbnail}>
              <div
                className={css.BookingPageCard__ThumbnailImage}
                style={{ backgroundImage: `url(${props.thumbnailUrl})` }}
              />
            </div>
          )}
          <div className={css.BookingPageCard__Heading}>
            <SingleLineTruncate maxLine={2} text={props.title} />
          </div>
          <div className={css.BookingPageCard__Description}>
            <MultipleLineTruncate maxLine={3} text={props.description} />
          </div>
          <div className={css.BookingPageCard__Clearfix} />
        </div>
        <div className={css.BookingPageCard__Footer}>
          <div className={css.BookingPageCard__Tags}>
            {/* なぜかundefindが渡ってくることがあるのでチェックしている */}
            {props.tags &&
              props.tags.length > 0 &&
              props.tags.map((tag, i) => <MerchantTag key={i} status={tag} />)}
          </div>
          {props.lowestPrice !== undefined &&
            props.lowestPrice !== null &&
            props.lowestPrice > 0 && (
              <div className={css.BookingPageCard__Price}>
                <LowestPrice lowestPrice={props.lowestPrice!} />
              </div>
            )}
        </div>
      </Link>
    </div>
  );
};

export default BookingPageCard;
